import * as React from 'react';
import { FieldArray } from 'formik';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import QuillEditor from 'src/components/Shared/QuillEditor';
import { Input } from 'src/components/Shared/BsInput';
import InputErrorClass from 'src/components/Shared/InputErrorClass';
import LesImages from 'src/containers/Shared/Images/';
import { LANGUAGES } from 'src/globals';

export default class Images extends React.Component<any, any> {

  private URL_BASE = process.env.REACT_APP_IMAGES_BASE_URL;

  constructor(props: any) {
    super(props);

    this.renderSelected = this.renderSelected.bind(this);
  }

  public render() {
    const { values, setFieldValue, errors, handleChange } = this.props;
    return (
      <div>
        <div className="form-group">
          <label>Tamaño</label>
          <select
            name="data.type"
            className="form-control"
            onChange={handleChange}
            value={values.data.type}
          >
            <option value=""></option>
            <option value="simple">Simple</option>
            <option value="fullscreen">Fullscreen</option>
          </select>
        </div>
        <div className="form-group">
          <label>Tipo</label>
          <select
            className={InputErrorClass({ errors, name: 'data.imagesFormat' })}
            name="data.imagesFormat"
            onChange={handleChange}
            value={values.data.imagesFormat}
          >
            <option value="">...</option>
            <option value="simple">Simple</option>
            <option value="horizontal">Slide horizontal</option>
            <option value="horizontal-alternative">Slide horizontal alternativo</option>
            <option value="horizontal-responsive">Slide horizontal responsive</option>
            <option value="vertical">Galeria vertical</option>
          </select>
          {errors['images.format'] && <p className="invalid-feedback">{errors['images.format']}</p>}
        </div>
        <FieldArray
          name="data.images"
          render={(arrayHelpers) => {
            return (
              <div>
                <div className="form-group pt-3">
                  <LesImages
                    onSelected={(selected: any) => {
                      if (!selected || !selected.length) {
                        return;
                      }

                      const images = selected.map((image: any, i: number) => {
                        return {
                          bucket: image.bucket,
                          name: image.name,
                          order: values.data.images.length + i + 1,
                          es: {
                            title: '',
                            subtitle: '',
                            description: '',
                            link: '',
                          },
                          en: {
                            title: '',
                            subtitle: '',
                            description: '',
                            link: '',
                          },
                          pt: {
                            title: '',
                            subtitle: '',
                            description: '',
                            link: '',
                          },
                          fr: {
                            title: '',
                            subtitle: '',
                            description: '',
                            link: '',
                          },
                          cn: {
                            title: '',
                            subtitle: '',
                            description: '',
                            link: '',
                          },
                          it: {
                            title: '',
                            subtitle: '',
                            description: '',
                            link: '',
                          },
                        };
                      });

                      setFieldValue('data.images', values.data.images.concat(images));
                    }}
                  />
                </div>
                {
                  values.data.images.map((d: any, i: number) =>
                    this.renderSelected(d, i, arrayHelpers, setFieldValue)
                  )
                }
              </div>
            );
          }}
        />
      </div>
    )
  }

  private renderSelected(image: any, index: number, arrayHelpers: any, setFieldValue: any) {
    const { errors } = this.props;
    return (
      <div className="card mb-3" key={index}>
        <div className="card-body">
          <div className="row">
            <div className="col-md-4 pt-3">
              <img
                src={`${this.URL_BASE}/r/${image.bucket}/200x200/${image.name}`}
                style={{
                  width: '100%',
                }}
              />
            </div>
            <div className="col-md-12">
              <Input
                label="Orden"
                value={image.order}
                name={`data.images.${index}.order`}
                onChange={this.props.handleChange}
                errors={errors}
                type="number"
              />
              <Tabs className="nav-fill" style={{ cursor: 'pointer' }}>
                <TabList>
                  {
                    Object.keys(LANGUAGES).map((key: string, i: number) => (
                      <Tab key={i}>{LANGUAGES[key]}</Tab>
                    ))
                  }
                </TabList>
                {
                  Object.keys(LANGUAGES).map((key: string, i: number) => (
                    <TabPanel key={i}>
                      <Input
                        label={`Titulo (${key})`}
                        name={`data.images.${index}.${key}.title`}
                        onChange={this.props.handleChange}
                        value={image[key].title}
                        errors={errors}
                      />
                      <Input
                        label={`Subtitulo (${key})`}
                        name={`data.images.${index}.${key}.subtitle`}
                        onChange={this.props.handleChange}
                        value={image[key].subtitle}
                        errors={errors}
                      />
                      <QuillEditor
                        label={`Descripcion (${key})`}
                        value={image[key].description}
                        onChange={(value: any) => {
                          setFieldValue(`data.images.${index}.${key}.description`, value);
                        }}
                      />
                      <Input
                        label={`Link (${key})`}
                        name={`data.images.${index}.${key}.link`}
                        onChange={this.props.handleChange}
                        value={image[key].link}
                        errors={errors}
                      />
                    </TabPanel>
                  ))
                }
              </Tabs>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="text-right">
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                e.preventDefault();
                arrayHelpers.remove(index);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

    );
  };
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Images.tsx